import "./credenciamentoFechado.css";
import "../../styles/bg-responsive.css";
import "../../styles/auth-logo.css";
import sbfLogo from "../../assets/SBF-Logo-1.png";
import { useNavigate } from "react-router-dom";

const CredenciamentoFechado = () => {
  const navigate = useNavigate();

  return (
    <div className="container-credenciamento-fechado">
      <div className="logo-wrapper">
        <img
          src={sbfLogo}
          alt="SBF"
          className="logo-credenciamento-fechado"
        />
      </div>
      <div className="conteudo-credenciamento-fechado">
        <p className="credenciamento-fechado-eyebrow">Credenciamento</p>
        <h1>Credenciamento encerrado</h1>
        <p>
          O período de credenciamento do SBF 2026 foi
          encerrado. Não é mais possível incluir novos participantes.
        </p>
        <p>
          Se você já possui acesso à plataforma, utilize o login com suas
          credenciais. Em caso de dúvidas, entre em contato pelo e-mail{" "}
          <b>sbf@informa.com</b>.
        </p>
        <button
          type="button"
          className="btn-voltar-login"
          onClick={() => navigate("/login")}
        >
          Ir para o login
        </button>
      </div>
    </div>
  );
};

export default CredenciamentoFechado;
